import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import CardTitle from 'components/CardTitle';
import Box from '@mui/material/Box';
import { Divider, Grid } from '@mui/material';

const SingleViewDialog = ({ open, onClose, title, children, data, image }) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md" >
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pl: 2, pr: 1, pt: 1, zoom: '0.9', width: '99%' }}>

        <div className='w-full'><CardTitle title={data.title} /></div>
        <IconButton edge="end" color="inherit" onClick={onClose} aria-label="close">
          <CloseIcon />
        </IconButton>
      </Box>
      <div className='px-5 w-full'>
        <Divider />
      </div>


      <div className='p-3 pb-5' style={{ zoom: '0.9' }}>
        <div className='flex items-center'>
          {image && <div className='pr-4'>
            {image}
          </div>
          }
          <div className='px-2 w-full'>

            <Grid container className="w-full">
              {data?.otherData?.map((item) => {
                return (
                  <Grid item size={{ sm: 12, sx: 12, md: 6, lg: 6 }}>
                    <table>
                      <tr>
                        <td>
                          <span className='font-semibold'>{item?.label} </span>
                        </td>
                        <td>
                          :
                        </td>
                        <td>
                          {item?.value}
                        </td>
                      </tr>
                    </table>
                  </Grid>
                )
              })}

            </Grid>




          </div>
        </div>

      </div>


    </Dialog>
  );
};

SingleViewDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.node.isRequired,
  children: PropTypes.node,
};

export default SingleViewDialog;